





























import Vue from "vue";
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    props:  {
        fileType: {
            type: String,
            required: false,
            default: "image/*"
        },
    },
    data: function() {
        return {
            dragOverActive: false,
            uniqueId: uuidv4()
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        })
    },

    mounted: function() {
        // set HTML elements
        const dropArea = document.getElementById(`picturesDropArea-${this.uniqueId}`);
        if (dropArea == undefined) {
            return;
        }

        // prevent defaults for all drag events
        dropArea.addEventListener("dragenter", this.preventDefaults, false);
        dropArea.addEventListener("dragover", this.preventDefaults, false);
        dropArea.addEventListener("dragleave", this.preventDefaults, false);
        dropArea.addEventListener("drop", this.preventDefaults, false);

        // handle drag and drop
        dropArea.addEventListener("dragover", this.handleDragover, false);
        dropArea.addEventListener("dragleave", this.handleDragLeave, false);
        dropArea.addEventListener("drop", this.handleDrop, false);
    },

    methods: {
        preventDefaults: function(event: DragEvent) {
            event.preventDefault();
            event.stopPropagation();
        },

        handleFileSelect: function({ target }: InputEvent) {
            this.interact();
            this.emitHandlePicture((target as HTMLInputElement).files as FileList);
        },

        handleDrop: function({ dataTransfer }: DragEvent) {
            this.dragOverActive = false;
            this.interact();
            this.emitHandlePicture(dataTransfer?.files as FileList);
        },

        emitHandlePicture: function(files: FileList) {
            Array.from(files).forEach(file => this.$emit("handlePicture", file));
        },

        handleDragover: function() {
            this.dragOverActive = true;
        },

        handleDragLeave: function() {
            this.dragOverActive = false;
        },

        interact: function() {
            this.$emit("interact");
        }
    }
});

